import { render, staticRenderFns } from "./cell-number.vue?vue&type=template&id=4c2f17a2&scoped=true"
import script from "./cell-number.ts?vue&type=script&lang=ts&external"
export * from "./cell-number.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f17a2",
  null
  
)

export default component.exports